<template>
  <b-container>
    <ValidationObserver ref="serviceFormObserver" v-slot="{ handleSubmit }">
      <card>
        <div slot="header" class="d-flex justify-content-between">
          <h4 class="card-title">{{ $t("message.editService") }}</h4>
          <div>
            <router-link to="/management/services">
              <n-button type="secondary" class="mr-1" simple>{{
                $t("message.cancel")
              }}</n-button>
            </router-link>
            <n-button
              type="primary"
              native-type="submit"
              :busy="isSubmitting"
              :disabled="isSubmitting"
              @click.native="handleSubmit(submit)"
            >
              {{ $t("message.save") }}
            </n-button>
          </div>
        </div>
        <div v-if="isLoading" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <service-form v-else v-model="model"></service-form>
      </card>
    </ValidationObserver>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver } from "vee-validate";
import ServiceForm from "./ServiceForm";
import { service } from "./services.lib";

export default {
  components: {
    ValidationObserver,
    ServiceForm
  },
  data() {
    return {
      model: null,
      isLoading: false,
      isSubmitting: false
    };
  },
  methods: {
    ...mapActions({
      fetchService: "services/fetchService",
      updateService: "services/updateService"
    }),
    showLoadingIndicator() {
      this.isLoading = true;
    },
    hideLoadingIndicator() {
      this.isLoading = false;
    },
    async submit() {
      this.showSubmittingIndicator();
      try {
        await this.updateService(this.model);
        this.$notify({
          type: "success",
          text: this.$t("message.serviceSaved")
        });
        this.$router.push("/management/services");
      } catch (e) {
        this.$notify({
          type: "error",
          title: "Error",
          text: e.message
        });
      } finally {
        this.hideSubmittingIndicator();
      }
    },
    showSubmittingIndicator() {
      this.isSubmitting = true;
    },
    hideSubmittingIndicator() {
      this.isSubmitting = false;
    }
  },
  computed: {
    ...mapGetters({ serviceById: "services/serviceById" }),
    id() {
      return this.$route.params.id;
    },
    service() {
      return this.serviceById(this.id);
    }
  },
  async created() {
    this.showLoadingIndicator();
    try {
      await this.fetchService(this.id);
      this.model = service(this.service);
      this.hideLoadingIndicator();
    } catch (e) {
      this.$notify({
        type: "error",
        title: "Error",
        text: e.message
      });
      this.$router.push("/management/services");
    }
  }
};
</script>
